import * as React from 'react';
import { useStyles } from './Style'
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { visuallyHidden } from '@mui/utils';
import AddParticipantModal from '../AddParticipantModal/AddParticipantModal';
import ParticipantCard from '../ParticipantCard/ParticipantCard';
import ProgressBar from '../ProgressBar/ProgressBar';
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import Pic from '../../../Images/admin/picture.png'
import { useDispatch, useSelector } from 'react-redux';
import Select, { selectClasses } from '@mui/joy/Select';
import Option from '@mui/joy/Option';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import AdminTheme from '../../Common/AdminTheme';
import { PartcipantsAPI, PartcipantsSearchAPI } from '../../../redux/Action/Admin/Partcipants/Partcipants';
import { PartcipantsProgramListingAPI } from '../../../redux/Action/Admin/ParticipantProgramLisiting/ParticipantProgram';
import { PartcipantsActivitesAPI } from '../../../redux/Action/Admin/PartcipantActivites/PartcipantActivities';
import { DeletePartcipantsActivitesAPI } from '../../../redux/Action/Admin/PartcipantActivites/DeletePartcipantActivites';
import { EventDashboardAPI } from '../../../redux/Action/Admin/EventList/EventDashboardList';
import { BulkDeleteProgramAPI } from '../../../redux/Action/Admin/ParticipantProgramLisiting/BulkDeleteProgram';
import SearchBar from '../SearchBar/SearchBar';
import { useState } from 'react';
import { useEffect } from 'react';
import AdmLoader from '../AdmLoader/AdmLoader';
import { Clear_ResetPassword_Check } from '../../../redux/Reducer/ResetPassword/ResetPAsswordSlice';
import Snacbar from '../../../Components/Snackbar/Snacbar';
import DeletePopup from '../DeletePopup/DeletePopup';
import { GetEditEventListAPI } from '../../../redux/Action/Admin/getEditEventList/GetEditEventList';
import { useNavigate } from 'react-router-dom';
import { ArchiveEvent } from '../../../redux/Action/Admin/ArchiveEvents/ArchiveEvent';
import RestoreIcon from '@mui/icons-material/Restore';
import { RestoreEventAPI } from '../../../redux/Action/RestoreEvent/RestoreEvent';
import { Clear_RestoreEvent_Check } from '../../../redux/Reducer/RestoreEvent/RestoreEventSlice';
import { AdminDeleteArchiveEventAPI } from '../../../redux/Action/Admin/EventList/DeleteEvent';
function AuthorAction({ eventid }) {
  const [open, setOpen] = React.useState(false);
  const [opendelete, setOpendelete] = React.useState(false);
  const dispatch = useDispatch();
  const classes = useStyles();
  const programactivitesID = localStorage.getItem("programactivitesID")
  const navigate = useNavigate()
  const [DeleteID, setDeleteId] = useState()
  const getEditEventListSlice = useSelector(state => state?.getEditEventListSlice)

  const handleEdit = (e) => {
    localStorage.setItem("archive",true)
    localStorage.setItem("typecheck", 'edit')

    // console.log("ee", eventid, open)
    dispatch(GetEditEventListAPI(eventid))
  }
  const handleRestore = (e) => {
    // console.log("ee", eventid, open)
    dispatch(RestoreEventAPI(eventid))
  }
  const handleDelete = (id) => {
    // dispatch(AdminDeleteEventAPI(id))
    setDeleteId(id)
    setOpen(true)
}
  const handleDeleteevent = () => {
    // eventid
    dispatch(AdminDeleteArchiveEventAPI(eventid))
    setOpen(false);
}
  useEffect(() => {
    if (getEditEventListSlice?.value?.success == true) {
      navigate(`/admin/events/create-event/event-information/${getEditEventListSlice?.value?.data?.id}`)
    }
    // console.log("getEditEventListSlice", getEditEventListSlice)
  }, [getEditEventListSlice])
  return (
    <>
      <div className={classes.ActionRow}>
        <IconButton aria-label="restore" onClick={(e) => handleRestore(e)}>
          <RestoreIcon />
        </IconButton>
        <IconButton aria-label="edit" onClick={(e) => handleEdit(e)}>
          <EditNoteRoundedIcon />
        </IconButton>
        <IconButton className='btn-delete' aria-label="delete"
                    onClick={() => handleDelete(eventid)}
                // onClick={() => setOpen(true)}
                >
                    <DeleteIcon
                    // onClick={() => handleDelete(eventid)}
                    />
                </IconButton>

      </div>
      <DeletePopup setOpen={setOpen} open={open} handleDelete={() => handleDeleteevent()} />


    </>
  );
}



function createData(id, authors, checkIn, foodVoucherLeft, gameBooth, progress, action) {
  return {
    id,
    authors,
    checkIn,
    foodVoucherLeft,
    gameBooth,
    progress,
    action,
  };
}

const rows = [
  createData(1,
    <ParticipantCard
      Image={Pic}
      Name="Janice wang"
      Validity="16 Dec, 2024 to 19 Dec, 2024"
    />,
    '1/5',
    '5/5',
    '0/5',
    <ProgressBar Value="25" />,
    // <AuthorAction />
  ),
  createData(2,
    <ParticipantCard
      Image={Pic}
      Name="Janice wang"
      Validity="16 Dec, 2024 to 19 Dec, 2024"
    />,
    '2/5',
    '4/5',
    '0/5',
    <ProgressBar Value="25" />,
    // <AuthorAction />
  ),
  createData(3,
    <ParticipantCard
      Image={Pic}
      Name="Janice wang"
      Validity="16 Dec, 2024 to 19 Dec, 2024"
    />,
    '3/5',
    '3/5',
    '0/5',
    <ProgressBar Value="100" />,
    // <AuthorAction />
  ),
  createData(4,
    <ParticipantCard
      Image={Pic}
      Name="Janice wang"
      Validity="16 Dec, 2024 to 19 Dec, 2024"
    />,
    '4/5',
    '2/5',
    '0/5',
    <ProgressBar Value="50" />,
    // <AuthorAction />
  ),
  createData(5,
    <ParticipantCard
      Image={Pic}
      Name="Janice wang"
      Validity="16 Dec, 2024 to 19 Dec, 2024"
    />,
    '5/5',
    '1/5',
    '0/5',
    <ProgressBar Value="90" />,
    // <AuthorAction />
  ),
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  // console.log("array", array)
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}



function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  const ProgramListingSlice = useSelector(state => state?.ProgramListingSlice)
  const ProgramListing = ProgramListingSlice?.value?.data?.map((data) => ({
    id: data?.title,
    numeric: false,
    label: data?.title,
  }))
  const headCells = [
    {
      id: 'Name',
      numeric: false,
      label: 'Name',
    },
    {
      id: 'Start_date',
      numeric: true,
      label: 'Start date',
    },
    {
      id: 'End_date',
      numeric: true,
      label: 'End date',
    },
    {
      id: 'action',
      numeric: true,
      label: 'Action',
    },



  ];

  // console.log("ProgramListingSlice", headCells)
  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          />
        </TableCell> */}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            // align={headCell.numeric ? 'right' : 'left'}
            align='center'
            padding={headCell.disablePadding ? 'none' : 'normal'}
          // sortDirection={orderBy === headCell.id ? order : false}
          >
            {/* <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            > */}
            {headCell.label}
            {/* {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null} */}
            {/* </TableSortLabel> */}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { numSelected, Data, selected, page, pagecheck, setPage, setSelected } = props;
  const classes = useStyles();
  const dispatch = useDispatch()
  const [selectedvalue, setselectedvalue] = React.useState("")
  const ProgramListingSlice = useSelector(state => state?.ProgramListingSlice)
  const [search, setsearch] = useState("");
  const [open, setOpen] = useState(false)
  const [pickupsearchcheck, setpickupsearchcheck] = useState(false)
  const SingleDeleteEventSlice = useSelector(state => state?.SingleDeleteEventSlice)
  const AdminBulkDeleteEventSlice = useSelector(state => state?.AdminBulkDeleteEventSlice)

  // React.useEffect(() => {
  //   localStorage.setItem("programactivitesID", Data[0]?.id)
  //   // if(pagecheck==false){
  //   if (Data[0]?.id != undefined) {
  //     setselectedvalue(Data[0]?.id)
  //     dispatch(PartcipantsProgramListingAPI(Data[0]?.id))
  //     dispatch(EventDashboardAPI(Data[0]?.id))
  //     localStorage.setItem("participantpage", page + 1)

  //     dispatch(PartcipantsAPI(Data[0]?.id, page + 1))
  //   }
  //   // }
  // }, [Data, AdminBulkDeleteEventSlice, SingleDeleteEventSlice])

  // const handleChange = (event, newValue) => {
  //   // console.log("Data", Data,newValue)
  //   setPage(0)
  //   setselectedvalue(newValue)
  //   localStorage.setItem("programactivitesID", newValue)
  //   dispatch(PartcipantsProgramListingAPI(newValue))
  //   dispatch(EventDashboardAPI(newValue))
  //   localStorage.setItem("participantpage", 1)

  //   dispatch(PartcipantsAPI(newValue, 1))
  // }
  // const joinselected = selected?.map(String).join(',')
  // const handleDelete = () => {
  //   setOpen(true)
  //   // const formData = new FormData();
  //   // formData.append(`participant_ids`, joinselected);
  //   // dispatch(BulkDeleteProgramAPI(formData, selectedvalue))

  // }
  // const handleDeleteevent = () => {

  //   const formData = new FormData();
  //   formData.append(`participant_ids`, joinselected);
  //   dispatch(BulkDeleteProgramAPI(formData, selectedvalue))
  //   setSelected([])

  // }
  // React.useEffect(() => {
  //   // PartcipantsSearchAPI
  // }, [search])
  // const searchtextbox = () => {
  //   dispatch(PartcipantsSearchAPI(selectedvalue, search))

  // }
  // console.log("ArchiveEventSliceData", Data)

  // useEffect(() => {
  //   const delay = 500; // Adjust the debounce delay in milliseconds
  //   const timerId = setTimeout(() => {
  //     if (pickupsearchcheck == true) {

  //       searchtextbox();
  //     }
  //   }, delay);

  //   // Cleanup the timer when the component unmounts or when inputValue changes
  //   return () => clearTimeout(timerId);
  // }, [search]);
  // console.log("ProgramListingSlice", ProgramListingSlice)
  return (
    <div className={classes.ParticipantTableHeader}>
      <div className={classes.ParticipantTableHeaderLeft}>
      
          <h4 id="tableTitle">All Archive</h4>
      
        {/* <p>180 Participants</p> */}
      </div>
      {/* <div className={classes.ParticipantTableHeaderRight}>
        <div className='rw'>
          <div className='cl'>
            <SearchBar search={search} setsearch={setsearch} setpickupsearchcheck={setpickupsearchcheck} />
          </div>

        </div>

      </div> */}

    </div>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function ArchiveTable() {
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('checkIn');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [pagecheck, setPagecheck] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const AdminEventListSlice = useSelector(state => state?.AdminEventListSlice)
  const PartcipantSlice = useSelector(state => state?.PartcipantSlice)
  const ResetPasswordSlice = useSelector(state => state?.ResetPasswordSlice)
  const [success, setsuccess] = useState(false)

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const [Data, setdata] = React.useState([])
  const [Datalength, setdatalength] = React.useState([])
  const [Datas, setdatas] = React.useState([])
  const dispatch = useDispatch()
  const programactivitesID = localStorage.getItem("programactivitesID")
  const SingleDeleteEventSlice = useSelector(state => state?.SingleDeleteEventSlice)
  const ArchiveEventSlice = useSelector(state => state?.ArchiveEventSlice)
  const RestoreEventSlice = useSelector(state => state?.RestoreEventSlice)

  React.useEffect(() => {
    if (ArchiveEventSlice?.value?.data != undefined) {
      // console.log("adminEvent", PartcipantSlice)
      setdata(ArchiveEventSlice?.value?.data?.event)
      setdatalength(ArchiveEventSlice?.value?.data?.pagination?.count)
    } else if (ArchiveEventSlice?.error?.message) {
      setdata([])
      setdatalength([])
    }
  }, [ArchiveEventSlice])
  console.log("ArchiveEventSlice", ArchiveEventSlice)
  // console.log("Datalength?.pagination?.count", Data)
  React.useEffect(() => {
    if (ArchiveEventSlice?.value?.data != undefined) {
      // console.log("adminEvent", AdminEventListSlice)
      setdatas(ArchiveEventSlice?.value?.data?.event)
    }
  }, [ArchiveEventSlice])
  React.useEffect(() => {
    // setselectedvalue(Data[0]?.id)
    // dispatch(PartcipantsProgramListingAPI(Data[0]?.id))
    // dispatch(EventDashboardAPI(Data[0]?.id))
    // localStorage.setItem("programactivitesID", Data[0]?.id)
    if (ArchiveEventSlice && ArchiveEventSlice !== null && ArchiveEventSlice !== undefined && ArchiveEventSlice !== "undefined") {
      // localStorage.setItem("participantpage", page + 1)
      dispatch(ArchiveEvent( page + 1))
    }
  }, [page, programactivitesID])

  // console.log("PartcipantSlice", PartcipantSlice)

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = PartcipantSlice?.value?.data?.user?.map((n) => n.user_id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setPagecheck(true)
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    setPagecheck(true)
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(Data, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, Data],
  );

  const classes = useStyles();
  useEffect(() => {
    if (ResetPasswordSlice?.value?.message) {

      setsuccess(true);
      // setOpentrue(false);

      // setnewPassworderror("")
      // setConfirmPassword("")
      setTimeout(() => {
        dispatch(Clear_ResetPassword_Check())
      }, 3000)
    }
  }, [ResetPasswordSlice])
  useEffect(() => {
    if (RestoreEventSlice?.value?.message) {

      setsuccess(true);
      // setOpentrue(false);

      // setnewPassworderror("")
      // setConfirmPassword("")
      setTimeout(() => {
        dispatch(Clear_RestoreEvent_Check())
      }, 3000)
    }
    if (RestoreEventSlice?.error?.message) {

      setsuccess(true);
      // setOpentrue(false);

      // setnewPassworderror("")
      // setConfirmPassword("")
      setTimeout(() => {
        dispatch(Clear_RestoreEvent_Check())
      }, 3000)
    }
  }, [RestoreEventSlice])

  useEffect(() => {
    dispatch(ArchiveEvent())
  }, [])
  // console.log("PartcipantSlice?.value?.data?.user?", Data, visibleRows)
  return (
    <>
    {
      PartcipantSlice?.loading == true && (
        <AdmLoader />
      )
    }
    {
      RestoreEventSlice?.loading == true && (
        <AdmLoader />
      )
    }
      {
        (ResetPasswordSlice?.value?.message) && (
          <Snacbar
            open={success}
            setOpen={setsuccess}
            messagetype={"success"}
            message={(ResetPasswordSlice?.value?.message)}
          />

        )
      }
      {
        (RestoreEventSlice?.value?.message) && (
          <Snacbar
            open={success}
            setOpen={setsuccess}
            messagetype={"success"}
            message={(RestoreEventSlice?.value?.message)}
          />

        )
      }
      {
        (RestoreEventSlice?.error?.message) && (
          <Snacbar
            open={success}
            setOpen={setsuccess}
            messagetype={"success"}
            message={(RestoreEventSlice?.error?.message)}
          />

        )
      }
      <div className={classes.ParticipantTable}>
        <EnhancedTableToolbar numSelected={selected.length} Data={Datas} selected={selected} page={page} setPage={setPage} pagecheck={pagecheck} setSelected={setSelected} />
        {Data?.length > 0 ? (
          <>
            <TableContainer>
              <Table
                sx={{ minWidth: 750 }}
                aria-labelledby="tableTitle"
              >
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={PartcipantSlice?.value?.data?.user?.length}
                />
                <TableBody>
                  {Data?.map((row, index) => {
                    const isItemSelected = isSelected(row.user_id);
                    const labelId = `enhanced-table-checkbox-${index}`;

                    return (
                      <TableRow
                        hover

                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.user_id}
                        selected={isItemSelected}
                        sx={{ cursor: 'pointer' }}
                      >
                        {/* <TableCell padding="checkbox"
                          onClick={(event) => handleClick(event, row.user_id)}
                        >
                          <Checkbox
                            color="primary"
                            checked={isItemSelected}
                            inputProps={{
                              'aria-labelledby': labelId,
                            }}
                          />
                        </TableCell> */}
                        <TableCell
                          // component="th"
                          id={labelId}
                          scope="row"
                          align="left"
                        >
                          {row?.name}
                        </TableCell>
                        <TableCell
                          // component="th"
                          id={labelId}
                          scope="row"
                          padding="none"
                          align="center"
                        >
                          {row?.start_date}
                        </TableCell>
                        <TableCell
                          // component="th"
                          id={labelId}
                          scope="row"
                          padding="none"
                          align="center"
                        >
                          {row?.end_date}
                        </TableCell>
                        {/* <TableCell align="center">{row?.checked_in}</TableCell> */}

                        <TableCell align="center"><AuthorAction eventid={row?.id} /></TableCell>
                      </TableRow>
                    );
                  })}
                  {/* {emptyRows > 0 && (
                    <TableRow>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )} */}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10]}
              component="div"
              count={Datalength}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />

          </>
        ) : <>
          <div className={classes.PlaceHolder}>
            No Event Found.
          </div>
        </>}
      </div>
    </>
  );
}